import type { IDepositTerminationApplicationForm } from "@/modules/application/common/types";
import { depositTerminationApplicationValidationSchema } from "@/modules/application/validations";
import { CloudflareAsset, SideSheetPosition, StaticUrl } from "@/shared/common/enums";
import type { IOperationPageProps } from "@/shared/common/types";
import { CloudFlareImage, InfoLinks, PageHeader } from "@/shared/components";
import { useMediaQuery, useTranslationExists } from "@/shared/hooks";
import { Button } from "@ab.uitools/ui-library/components/Button";
import { FormContainer } from "@ab.uitools/ui-library/components/FormContainer";
import { SideSheet } from "@ab.uitools/ui-library/components/SideSheet";
import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import { Text } from "@ab.uitools/ui-library/components/Text";
import { useState } from "react";

import { DepositTerminationApplicationForm } from "./DepositTerminationApplicationForm";

export const DepositTerminationApplication = ({ isEdit, isCopy }: IOperationPageProps) => {
  const { t, exists } = useTranslationExists();
  const isDesktop = useMediaQuery();
  const [isSideBarOpen, setSideBarOpen] = useState<boolean>(false);

  const initialValues: IDepositTerminationApplicationForm = {
    depositNumber: "",
    purpose: t("application.depositTermination.purpose"),
    applicationNumber: "",
    isAgreeWithConditions: false,
  };

  return (
    <>
      <FormContainer
        className="full-width page-container form-layout"
        formId="form-container"
        mode="onBlur"
        reValidateMode="onBlur"
        initialValues={initialValues}
        validationScheme={depositTerminationApplicationValidationSchema({ t })}
      >
        <PageHeader>
          {!isSideBarOpen && exists("application.sidebarTitle") && (
            <Button
              type="secondary"
              size="small"
              className="side-sheet-btn"
              data-testid="open-info-side-sheet"
              data-ga-id="open-info-side-sheet"
              data-ga-action="Open Deposit termination application info side sheet"
              iconProps={{
                Component: (props: ISVGIconProps) => (
                  <CloudFlareImage {...props} path={CloudflareAsset.Info}/>
                ),
                alignment: "left",
              }}
              onClick={() => setSideBarOpen(!isSideBarOpen)}
            />
          )}
        </PageHeader>
        <DepositTerminationApplicationForm
          isEdit={isEdit}
          isCopy={isCopy}
        />
      </FormContainer>
      <SideSheet
        position={isDesktop ? SideSheetPosition.Right : SideSheetPosition.Bottom}
        isPositioned={!isDesktop}
        withOverlay={!isDesktop}
        isOpen={isSideBarOpen}
        onClose={() => setSideBarOpen(false)}
        title={t("application.sidebarTitle")}
      >
        <div className="flexbox flex-wrap--wrap">
          <Text type="primary" className="mb-10">
            {t("application.depositTermination.sidebarMessage")}
          </Text>
          <InfoLinks keys={[StaticUrl.DepositTermsAndConditions]}/>
        </div>
      </SideSheet>
    </>
  );
};
